module.exports = __webpack_public_path__ + "static/media/slider-new-arivals.8610093e.jpg";